import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { supabase } from '../supabase';
import { useAuth } from '../hooks/useAuth';
import LogoDisplay from './LogoDisplay';

const Header = () => {
  const { user } = useAuth();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-50 backdrop-blur-md bg-white/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 md:gap-3 group">
          <div className="h-10 w-10 md:h-14 md:w-14 rounded-lg md:rounded-xl overflow-hidden group-hover:scale-105 transition-transform shadow-sm border border-gray-200 bg-white flex items-center justify-center p-1">
            <LogoDisplay alt="Arboleda Bienes Raíces" className="w-full h-full object-contain" />
          </div>
          <div className="flex flex-col">
            <h1 className="text-sm md:text-xl font-black tracking-tighter text-emerald-900 leading-none">ARBOLEDA</h1>
            <p className="text-[8px] md:text-[10px] text-emerald-600 font-bold uppercase tracking-[0.1em] md:tracking-[0.2em]">Bienes Raíces</p>
          </div>
        </Link>

        <nav className="flex items-center gap-3 md:gap-6">
          <Link 
            to="/" 
            className={`text-[10px] md:text-sm font-black uppercase tracking-widest transition-colors ${location.pathname === '/' ? 'text-emerald-700' : 'text-gray-400'}`}
          >
            <span className="hidden md:inline">PROPIEDADES</span>
            <SafeIcon icon={FiIcons.FiSearch} className="md:hidden text-lg" />
          </Link>
          
          {user ? (
            <div className="flex items-center gap-2 md:gap-4 pl-3 md:pl-6 border-l border-gray-100">
              <Link 
                to="/executive" 
                className={`text-[10px] md:text-sm font-black uppercase tracking-widest px-3 py-2 rounded-lg transition-all ${location.pathname === '/executive' ? 'bg-emerald-50 text-emerald-700' : 'text-gray-600'}`}
              >
                <span className="hidden md:inline">PANEL</span>
                <SafeIcon icon={FiIcons.FiGrid} className="md:hidden text-lg" />
              </Link>
              <button 
                onClick={handleLogout} 
                className="p-2 text-gray-400 hover:text-red-500 transition-colors"
                title="Cerrar Sesión"
              >
                <SafeIcon icon={FiIcons.FiLogOut} className="text-lg" />
              </button>
            </div>
          ) : (
            <Link to="/login" className="text-[10px] md:text-sm font-black uppercase tracking-widest text-gray-400 hover:text-emerald-700 transition-colors flex items-center gap-2">
              <SafeIcon icon={FiIcons.FiUser} className="text-lg" />
              <span className="hidden md:inline">ACCESO</span>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;